import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Select } from 'antd';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InfiniteScroll from 'react-infinite-scroller';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from 'firebase/firestore/lite';
import MusicArtist from '../MusicArtist/MusicArtist';
import MusicArtistSkeleton from '../skeletons/artistskeleton';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';

let backedAuthorArr = [];
let startAfterSnap = null;
let sortParam = {
  sortingField: 'creationDate',
  sortingOrder: 'desc',
};
let stopUpdate = false;
let callNo = 0;

export default function ArtistsContainer() {
  const router = useRouter();

  const isMobile = useMediaQuery('(max-width:1000px)');
  const [hasMore, sethasMore] = useState(true);
  const roomsData = useSelector((state) => state.nftReducer.roomsData);

  const [ratingFilter, setRatingFilter] = useState('sort');
  const [loadingArtists, setloadingArtists] = useState(false);
  const [artistDataArr, setartistDataArr] = useState([]);
  const [hardLoad, sethardLoad] = useState(false);

  let {
    filter: filter,
    sortBy: sortBy,
    searchQuery: searchQuery,
    room: roomFilter,
  } = router.query;
  useEffect(() => {
    return () => {
      // Executed only when component unmounts,
      backedAuthorArr = [];
      startAfterSnap = null;

      sortParam = {
        sortingField: 'creationDate',
        sortingOrder: 'desc',
      };
      stopUpdate = false;
      callNo = 0;
    };
  }, []);

  useEffect(() => {
    if (router.isReady) {
      console.log('router.query updated');
      stopUpdate = true;
      callNo = callNo + 1;
      updateSortParam();
      updateRoomParam();
      getData();
    }
  }, [router.query, router.isReady, sortBy]);

  const updateSortParam = async () => {
    if (sortBy) {
      if (sortBy === 'followers') {
        sortParam = {
          sortingField: 'followers',
          sortingOrder: 'desc',
        };
      } else if (sortBy === 'nftsCountLive') {
        sortParam = {
          sortingField: 'nftsCountLive',
          sortingOrder: 'desc',
        };
      } else if (sortBy === 'creationDate') {
        sortParam = {
          sortingField: 'creationDate',
          sortingOrder: 'desc',
        };
      } else if (sortBy === 'lowerCaseName') {
        sortParam = {
          sortingField: 'lowerCaseName',
          sortingOrder: 'asc',
        };
      }
    } else if (sortParam.sortingField !== 'creationDate') {
      sortParam = {
        sortingField: 'creationDate',
        sortingOrder: 'desc',
      };
    }
    backedAuthorArr = [];
    startAfterSnap = null;
    if (!hasMore) {
      sethasMore(true);
    }
  };

  const updateRoomParam = async () => {
    backedAuthorArr = [];
    startAfterSnap = null;
    if (!hasMore) {
      sethasMore(true);
    }
  };

  const getData = async () => {
    // console.log('get data called');
    sethardLoad(true);
    await getArtistsData(true, callNo);
    sethardLoad(false);
  };

  const getArtistsData = async (hard, lcallNo) => {
    const callNoVal = lcallNo;
    // console.log('callNoVal', hard, callNoVal);

    if (!loadingArtists || hard) {
      setloadingArtists(true);

      let queryArr = [];
      queryArr.push(collection(firebaseFireStore, 'musicartArtists'));
      queryArr.push(where('adminState', '==', 'APPROVED'));

      let filterArr = filter
        ? Array.isArray(filter)
          ? [...filter]
          : [filter]
        : [];

      if (
        !filterArr.includes('NA-Music') &&
        !filterArr.includes('Artwork and More')
      ) {
        queryArr.push(where('isMusicNftExits', '==', true));
      } else if (
        filterArr.includes('Artwork and More') &&
        filterArr.includes('NA-Music')
      ) {
        queryArr.push(where('isArtWorkNftExits', '==', true));
      }
      queryArr.push(orderBy(sortParam.sortingField, sortParam.sortingOrder));
      if (startAfterSnap) {
        queryArr.push(startAfter(startAfterSnap));
      }
      queryArr.push(limit(10));

      if (
        (hard && callNoVal && callNo && callNoVal !== callNo) ||
        (stopUpdate && !hard)
      ) {
        return null;
      }

      let dataRef = await getDocs(query(...queryArr));

      if (
        (hard && callNoVal && callNo && callNoVal !== callNo) ||
        (stopUpdate && !hard)
      ) {
        return null;
      }

      if (dataRef.empty) {
        if (backedAuthorArr.length !== artistDataArr.length) {
          let dataArr = [...backedAuthorArr];
          filterDataLocally(
            dataArr,
            false,
            false,
            false,
            false,
            null,
            null,
            ratingFilter,
            null,
          );
        }

        sethasMore(false);
        setloadingArtists(false);

        return;
      }

      let dataLen =
        dataRef && dataRef.docs && dataRef.docs.length
          ? dataRef.docs.length
          : 10;
      let dataArr = [...backedAuthorArr];
      dataRef.forEach((doc, key) => {
        if (dataLen && dataLen - 1 === key) {
          startAfterSnap = doc;
        }
        dataArr.push({ ...doc.data(), id: doc.id });
        // startAfterSnap = doc;
      });

      backedAuthorArr = [...dataArr];
      filterDataLocally(backedAuthorArr, false, false, false, false, false);
      if (stopUpdate) {
        stopUpdate = false;
      }
      setloadingArtists(false);
    }
  };

  const filterDataLocally = (artistDataArrParam, searchParam, ratingParam) => {
    let dataArr = [
      ...(artistDataArrParam ? artistDataArrParam : backedAuthorArr),
    ];
    //search
    let searchVal = searchQuery ? searchQuery : null;
    if (searchVal && searchVal !== '' && searchVal !== -1) {
      dataArr = dataArr.filter((x) => {
        if (
          (x.name && x.name.toLowerCase().includes(searchVal.toLowerCase())) ||
          (x.bio && x.bio.toLowerCase().includes(searchVal.toLowerCase()))
        ) {
          return x;
        }
      });
    }

    //room filter
    let roomsArrFilter = roomFilter
      ? Array.isArray(roomFilter)
        ? [...roomFilter]
        : [roomFilter]
      : null;

    if (
      roomsArrFilter &&
      roomsArrFilter.length > 0 &&
      roomsData &&
      roomsData.length > 0
    ) {
      let issuerIds = [];
      roomsArrFilter.map((roomId) => {
        let roomEleIndex = roomsData.findIndex((x) => roomId === x.id);
        if (roomEleIndex !== -1) {
          issuerIds = issuerIds.concat(roomsData[roomEleIndex].RoomID);
        }
      });

      dataArr = dataArr.filter((x) => {
        if (x.creatorId && issuerIds.includes(x.creatorId)) {
          return x;
        }
      });
    }

    setartistDataArr(dataArr);
  };

  return (
    <>
      <InfiniteScroll
        loadMore={() => getArtistsData()}
        hasMore={hasMore}
        threshold={isMobile ? 5000 : 1500}
        initialLoad={true}
      >
        <div className="row row--grid" key="1">
          {artistDataArr.length === 0 && hasMore === false ? (
            !loadingArtists && (
              <div className="no__result__alert">No result found</div>
            )
          ) : (
            <>
              {artistDataArr.map((ele, index) => {
                return (
                  <div
                    className="turning-screens 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12 py-2 w-full"
                    key={'artist' + index}
                  >
                    <MusicArtist ele={ele} />
                  </div>
                );
              })}

              {hasMore && (
                <>
                  {Array(10)
                    .fill()
                    .map((ele, index) => (
                      <MusicArtistSkeleton index={index} />
                    ))}
                </>
              )}
            </>
          )}
        </div>
      </InfiniteScroll>
    </>
  );
}
